module.exports = __webpack_public_path__ + "img/double-image-hero-ford.d49a1a34.png";